import { useEffect } from "react";
import { useControl } from "react-map-gl/mapbox";
import { useTheme } from "@mui/system";
import MapStyleToggleControl from "../utils/MapStyleToggleControl";

/**
 * Drop-in map control button that lets the user switch between the
 * "roadmap" and "satellite" map styles, matching the account page's
 * "Map Style" preference.
 *
 * @param {Object} props
 * @param {{ light: string, dark: string }} [props.roadmapStyle] - roadmap style pair used by this map (matches the pair passed to getMapStyle)
 * @param {string} [props.position] - Mapbox control position (default "top-left")
 */
const MapStyleControl = ({ roadmapStyle, position = "top-left" }) => {
  const theme = useTheme();

  const control = useControl(
    () => new MapStyleToggleControl({ roadmapStyle, themeMode: theme.palette.mode }),
    { position }
  );

  useEffect(() => {
    control.setThemeMode(theme.palette.mode);
  }, [control, theme.palette.mode]);

  return null;
};

export default MapStyleControl;
